import React from "react";
import QnectTextField from "../qnect-ui/qnect-text-field";
import QnectDateField from "../qnect-ui/qnect-date-field";
import QnectSelectField from "../qnect-ui/qnect-select-field";
import FieldWrapper from "../custom/field-wrapper";
import QnectButton from "../qnect-ui/qnect-button";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../custom/dialog-title";
import DialogSecondaryTitle from "../custom/dialog-secondary-title";
import Dialog from '../custom/dialog';
import {useDialogStyles} from "../custom/dialog-style";
import useConfig from "../qnect-ui/qnect-config";
import {_convertStringDateToMomentObject, _masked, isParentMember} from "../../utils/utility";

export const ViewUserDialog = ({open = false, onClose, onOk, heading, parentOptions, data, ...props}) => {
    const classes = useDialogStyles();
    const cfg = useConfig();
    return (
        <div>
            <Dialog open={open} onClose={onClose} className={classes.modal_box_container}>
                <DialogTitle className={classes.title}
                    title={cfg("policyDetailModals.userDetails.title")}
                    onClose={onClose} lang={props.lang}
                />
                <DialogSecondaryTitle title={heading} />
                <DialogContent>
                     <div className={classes.modal_box_form_container}>
                         <div className='modal_box_form_field input_relationship'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     field="relationshipUser"
                                     value={data?.relationship}
                                     errorMessage=''
                                     onChange=''
                                     placeholder=''
                                     formId=''
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         {
                             !isParentMember(data?.memberNo) &&
                             <div className='modal_box_form_field input_relationship'>
                                 <FieldWrapper >
                                     <QnectSelectField
                                         field="parentMembers"
                                         value={data?.parentMember}
                                         errorMessage=''
                                         onChange=''
                                         placeholder=''
                                         options={parentOptions}
                                         disabled={true}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         {
                             isParentMember(data?.memberNo) &&
                             <div className='modal_box_form_field input_employmentDate'>
                                 <FieldWrapper >
                                     <QnectDateField
                                         field="employmentDateUser"
                                         value={_convertStringDateToMomentObject(data?.employmentDate)}
                                         onChange=''
                                         disabled={true}
                                     />
                                 </FieldWrapper>
                             </div>
                         }
                         <div className='modal_box_form_field input_name'>
                             <FieldWrapper >
                                 <QnectTextField 
                                     field="nameUser"
                                     value={data?.name}
                                     errorMessage=''
                                     onChange=''
                                     placeholder=''
                                     formId=''
                                     disabled={true}
                                     label={ data?.relationship !== '00' ? cfg('genericLabels.dependentNameLabel') : null}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_effectiveDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     field="effectiveDateUser"
                                     value={_convertStringDateToMomentObject(data?.effectiveDate)}
                                     onChange=''
                                     disabled={true}
                                 />
                             </FieldWrapper>
                       </div>
                         <div className='modal_box_form_field input_dobDate'>
                             <FieldWrapper >
                                 <QnectDateField
                                     field="dateOfBirthUser"
                                     value={_convertStringDateToMomentObject(data?.dateOfBirth)}
                                     onChange=''
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_nricPassport'>
                             <FieldWrapper >
                                 <QnectTextField 
                                     field="nricPassportUser"
                                     value={_masked(data?.securityId)}
                                     errorMessage=''
                                     onChange=''
                                     placeholder=''
                                     formId=''
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_gender'>
                             <FieldWrapper >
                                 <QnectSelectField
                                     field="genderUser"
                                     value={data?.gender}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                         <div className='modal_box_form_field input_email'>
                             <FieldWrapper >
                                 <QnectTextField
                                     field="emailAddress"
                                     value={data?.emailAddress}
                                     disabled={true}
                                 />
                             </FieldWrapper>
                         </div>
                     </div>
                </DialogContent>
                <DialogActions className={classes.actions}>
                        <QnectButton onClick={onOk}>{"Close"}</QnectButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ViewUserDialog;

